// @flow

import React from 'react';

type CoveImageProps = {
  id?: string,
  class?: string,
  url: string,
  imageSizes: {
    min: number,
    max: number,
    step: number
  },
  aspectRatio: number,
  sizes: Array<Size>,
  alt: string
};

type Size = {
  breakpoint: string,
  width: string
};

export default class CoveImage extends React.PureComponent<CoveImageProps, *> {
  render() {
    let srcset = '';
    let url = this.props.url.replace(/http:/, '');

    if (this.props.imageSizes) {
      for (let size = this.props.imageSizes.max; size >= this.props.imageSizes.min; size -= this.props.imageSizes.step) {
        srcset += url + '.resize.' + size + 'x' + Math.floor(size * this.props.aspectRatio) + '.jpg ' + size + 'w';

        if (size > this.props.imageSizes.min) {
          srcset += ', ';
        }
      }
    }

    let sizes = this.props.sizes.reduce(function (sizes, size) {
      return sizes + ' (min-width: ' + size['breakpoint'] + ') ' + size['width'] + ', ';
    }, '') + '100vw';

    return (
      <img
        id={this.props.id || ''}
        className={this.props.class || ''}
        src={url}
        srcSet={srcset}
        sizes={sizes}
        alt={this.props.alt || ''}
        aria-hidden={this.props.ariaHidden || false} />
    );
  }
};